import React, {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useState,
} from "react";
import { adminLogin, adminLogout, adminSession } from "@/lib/adminApi";

const AdminAuthContext = createContext(null);

export function AdminAuthProvider({ children }) {
  // status: 'checking' | 'authenticated' | 'unauthenticated'
  const [status, setStatus] = useState("checking");
  const [email, setEmail] = useState(null);

  const refresh = React.useCallback(async () => {
    try {
      const data = await adminSession();
      if (data?.authenticated) {
        setEmail(data.email || null);
        setStatus("authenticated");
      } else {
        setEmail(null);
        setStatus("unauthenticated");
      }
    } catch {
      setEmail(null);
      setStatus("unauthenticated");
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const login = async (e, p) => {
    const data = await adminLogin(e, p);
    setEmail(data?.email || null);
    setStatus("authenticated");
    return data;
  };

  const logout = async () => {
    try {
      await adminLogout();
    } finally {
      setEmail(null);
      setStatus("unauthenticated");
    }
  };

  return (
    <AdminAuthContext.Provider value={{ status, email, login, logout, refresh }}>
      {children}
    </AdminAuthContext.Provider>
  );
}

export const useAdminAuth = () => useContext(AdminAuthContext);
